
import useAdBlockStore from "store/AdBlockStore";
import SuggestionsPanel from "./SuggestionsPanel";
import { OfferTextBuilder } from "./OfferTextBuilder";
import { IncentiveTextBuilder } from "./IncentiveTextBuilder";
import { isCouponAutoCheckExcluded } from "utils";

const OfferLeftPanel = () => {
    const leftPanelView = useAdBlockStore(state => state.leftPanelView);
    const activePageData = useAdBlockStore(state => state.activePageData);
    const activeBlockData = useAdBlockStore(state => state.activeBlockData);
    const updateMetaDataField = useAdBlockStore(state => state.updateMetaDataField);

    switch (leftPanelView) {
        case "offer_text":
            return <OfferTextBuilder
                view="edit"
                onStartChange={(e) => {
                    if (e) {
                        if ((activePageData?.pageType === "Coupon Page" && !isCouponAutoCheckExcluded(activeBlockData?.retailer_name)) || activePageData?.digital_coupon_f) {
                            updateMetaDataField("coupon_f", true);
                            updateMetaDataField("coupon_amnt", e);
                        }
                    }
                }} />
        case "incentive_text":
            return <IncentiveTextBuilder />
        case "offer":
        case "incentive":
            return <SuggestionsPanel />;
        default:
            return <SuggestionsPanel />;
    }
}

export default OfferLeftPanel;